import * as yup from 'yup'

export const specialCharactersMessaging = `Names can only include letters, numbers, and the following: '"-_/()#&*:,.`
export const BASICINPUTSCHEMA = yup
  .string()
  .trim()
  .matches(/^[\w\-\sáéíñóúüýÁÉÍÑÓÚÜÝ'“\-–/()#&*:,."”]+$/, {
    message: specialCharactersMessaging,
    excludeEmptyString: true,
  })
  .required('This field is required')
export const CREATECOURSESCHEMA = yup.object().shape({
  courseInstanceName: BASICINPUTSCHEMA,
  selectedCourse: yup.string().required(),
  selectedLicenseId: yup.string().required(),
})
export const DATE = yup.date()

// TODO RIght now we have k5 in v1 lms and ms in v1.5 lms in this off folder. To make sure we parse the instructoData correctly, we have this mapping.
// once we move everything to site selection this will just be erased with the rest of this off folder
export const getProgramLmsKey = currentProduct => {
  const productName = currentProduct?.name

  if (productName === 'Middle School') {
    return currentProduct?.['lmsKeyV1Dot5']
  }
  if (productName === 'Elementary') {
    return currentProduct?.['lmsKey']
  }
  console.warn('no lmsKey found for product', productName)
  return null
}
